import { DETERMINAR_PAGINA_ATUAL_ENCOMENDA } from '../types'

export default function determinarPaginaAtualEncomenda (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_ENCOMENDA,
    payload: paginaAtual
  }
}
